(function () {
  const root = document.documentElement;
  let resizeObserver;

  function getParts() {
    return {
      announcement: document.getElementById('HdrAnnouncementBar'),
      header:
        document.querySelector('.header-bar') ||
        document.querySelector('.section-header') ||
        document.querySelector('header')
    };
  }

  function setHeaderHeights() {
    const parts = getParts();
    const announcementHeight = parts.announcement ? parts.announcement.offsetHeight : 0;
    const headerHeight = parts.header ? parts.header.offsetHeight : 0;

    root.style.setProperty('--us-announcement-h', `${announcementHeight}px`);
    root.style.setProperty('--us-slide-header-h', `${headerHeight}px`);
  }

  function observeHeaderParts() {
    if (!('ResizeObserver' in window)) return;
    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(setHeaderHeights);
    const parts = getParts();

    if (parts.announcement) resizeObserver.observe(parts.announcement);
    if (parts.header) resizeObserver.observe(parts.header);
  }

  function refreshHeaderMeasurements() {
    setHeaderHeights();
    observeHeaderParts();
  }

  window.addEventListener('load', refreshHeaderMeasurements);
  window.addEventListener('resize', setHeaderHeights);
  document.addEventListener('shopify:section:load', refreshHeaderMeasurements);
  refreshHeaderMeasurements();
})();
